module.exports = __webpack_public_path__ + "static/media/mnist.4cb9b0a5.png";